var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { ProductType } from "../@types/enums/ProductType";
import DefaultBuyBox from "./default/DefaultBuyBox";
import ApparelBuyBox from "./apparel/ApparelBuyBox";
import { ProductBuyBoxSelectVariantTypeEnum } from "onnit-ui/lib/@types/interfaces/ProductBuyBoxSelectVariantConfig";
import CondensedBuyBox from "onnit-ui/lib/buybox/condensed/CondensedBuyBox";
function buyBoxVariant(props) {
    if (props.products[0].type_id === ProductType.APPAREL_CONTAINER) {
        return (React.createElement(ApparelBuyBox, __assign({}, props)));
    }
    var productBuyBoxSelectVariant = props.productBuyBoxSelectVariant;
    if (!productBuyBoxSelectVariant) {
        return (React.createElement(DefaultBuyBox, __assign({}, props)));
    }
    switch (productBuyBoxSelectVariant.variant) {
        case ProductBuyBoxSelectVariantTypeEnum.CONDENSED:
            return (React.createElement(CondensedBuyBox, __assign({}, props)));
        case ProductBuyBoxSelectVariantTypeEnum.DEFAULT:
        default:
            return (React.createElement(DefaultBuyBox, __assign({}, props)));
    }
}
function BuyBox(props) {
    if (!props.products || props.products.length === 0) {
        console.error("BuyBox: No products defined.");
        return null;
    }
    return buyBoxVariant(props);
}
export default BuyBox;
//# sourceMappingURL=BuyBox.js.map